import { useState, useEffect } from 'react';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Panel } from '../style';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useUser, useAuth } from '@clerk/clerk-react';

import CardInput from './CardInput';
import * as Api from '../Api';
import config from '../config';

function AddCardDialog({ handleClose }) {
  const [sourceKey, setSourceKey] = useState();
  const { user } = useUser();
  const { getToken } = useAuth();

  useEffect(() => {
    // TODO: check if user has stripe_id, if not, create one or have some sort of fallback
    const user_id = user.publicMetadata.stripe_id;
    getToken().then((token) => {
      Api.call(token, 'POST', `intent?user_id=${user_id}`).then((data) => {
        setSourceKey(data.client_secret);
      });
    });
  }, []);

  return (
    <Panel>
      <IconButton
        onClick={handleClose}
        style={{
          position: 'absolute',
          right: 5,
          top: 5,
        }}
      >
        <CloseIcon />
      </IconButton>
      {sourceKey && (
        <Elements
          stripe={loadStripe(String(config.STRIPE_PUBLIC_KEY))}
          options={{ clientSecret: String(sourceKey) }}
        >
          <CardInput></CardInput>
        </Elements>
      )}
    </Panel>
  );
}

export default AddCardDialog;
